var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgStar = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3082 27.7774C9.63206 28.1303 8.81413 28.0681 8.19911 27.6171C7.58409 27.1661 7.27894 26.4047 7.41228 25.6538L8.4914 19.4686L3.94817 15.1148C3.39284 14.5852 3.18932 13.7846 3.4243 13.0541C3.65928 12.3236 4.29136 11.7918 5.0513 11.6853L11.3593 10.7836L14.2071 5.10259C14.5448 4.42127 15.2395 3.99023 15.9999 3.99023C16.7603 3.99023 17.4549 4.42127 17.7926 5.10259L20.6405 10.7836L26.9484 11.6853C27.7084 11.7918 28.3404 12.3236 28.5754 13.0541C28.8104 13.7846 28.6069 14.5852 28.0515 15.1148L23.5083 19.4686L24.5874 25.6551C24.7208 26.4061 24.4156 27.1675 23.8006 27.6185C23.1856 28.0695 22.3677 28.1316 21.6916 27.7787L15.9999 24.8375L10.3082 27.7774Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgStar, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/star.3eb1ddfe.svg";
export { ForwardRef as ReactComponent };